module.exports = __webpack_public_path__ + "static/media/Delete.b6dd552c.svg";